import Button from "@material-ui/core/Button";
import DataTable from "react-data-table-component";
import Grid from "@material-ui/core/Grid";
import { useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Checkbox from "@material-ui/core/Checkbox";
import COLORS from "./../COLORS";
import DetailedScenarioVisualization from "./../DetailedScenarioVisualization";
import CustomModal from "./../CustomModal";
import KPIDetails from "../KPIDetails";
import React from 'react';
import {
  testScenarioDetailColumns,
  testScenarioDetailDataPassed,
  testScenarioDetailDataFailed,
} from "../data";

const customStyles = {
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      cursor: "pointer",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
};

const TestScenarioDetail = ({ testScenario, onBack }) => {
  const [
    selectedTestScenarioDetailedView,
    setSelectedTestScenarioDetailedView,
  ] = useState(null);
  const [selectedTestCaseStatus, setSelectedTestCaseStatus] = useState(
    testScenario.test_case_status
  );
const [RowsWithResult, setRowsWithResult]= useState("");
  const [columnVisibility, setColumnVisibility] = useState({
    scenario: true,
    kpi1: true,
    kpi2: true,
    kpi3: true,
    kpi4: true,
    kpi5: true, 
    kpi6: true,
    kpi7: true,
    result: true,
  });
  const [columnVisibilityChanged, setColumnVisibilityChanged] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedModalContent, setSelectedModalContent] = useState(null);

  const handleModalClose = () => {
    setIsOpenModal(false);
  };
  const handleColumnToggle = (columnName) => {
    setColumnVisibility((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName],
    }));
  };

  const calculateResult = (rowData) => {
    const { kpi1, kpi2, kpi3, kpi4, kpi5, kpi6, kpi7 } = rowData;

    const visibleKPIs = Object.keys(columnVisibility).filter(
      (key) => key.startsWith("kpi") && columnVisibility[key]
    );

    const allKPIsPassed = visibleKPIs.every(
      (kpiKey) => rowData[kpiKey] === "PASS"
    );

    return allKPIsPassed ? "PASS" : "FAIL";
  };
  const filteredColumns = testScenarioDetailColumns.filter(
    (column) => columnVisibility[column.selector]
  );

  const [displayData, setDisplayData] = useState(
    testScenario.test_case_status === "Executed"
      ? [...testScenarioDetailDataFailed, ...testScenarioDetailDataPassed]
      : testScenario.test_case_status === "Passed"
      ? testScenarioDetailDataPassed
      : testScenarioDetailDataFailed
  );

  const rowsWithResult = displayData.map((row) => ({
    ...row,
    result: calculateResult(row),
  }));
  const handleStatusUpdate = (status) => {
    setSelectedTestCaseStatus(status);
    setDisplayData(
      status === "Passed"
        ? testScenarioDetailDataPassed
        : testScenarioDetailDataFailed
    );
  };

  useEffect(() => {
    if (columnVisibilityChanged) {
      const updatedRowsWithResult = displayData.map((row) => ({
        ...row,
        result: calculateResult(row),
      }));
      setRowsWithResult(updatedRowsWithResult);
      setColumnVisibilityChanged(false);
    }
  }, [columnVisibility, displayData, columnVisibilityChanged]);

  const handleTooltipClick = (columnDetails) => {
    setSelectedModalContent(
      <KPIDetails dataPassed={columnDetails}></KPIDetails>
    );
    setIsOpenModal(true);
  };
  const handleRowClick = (row) => {
    setSelectedTestScenarioDetailedView(row);
  };

  if (selectedTestScenarioDetailedView) {
    return (
      <DetailedScenarioVisualization
        testScenario={selectedTestScenarioDetailedView}
        onBack={() => setSelectedTestScenarioDetailedView(null)}
      />
    );
  }
  return (
    <>
      <Grid container spacing={24}>
        <Grid item xs={5}>
          <Button onClick={onBack} variant="contained">
            Back
          </Button>
        </Grid>
        <Grid item xs={3}>
          <FormGroup>
            <FormControl>
              <Select
                value={selectedTestCaseStatus}
                onChange={(e) => handleStatusUpdate(e.target.value)}
              >
                <MenuItem value={"Executed"}>Executed</MenuItem>
                <MenuItem value={"Passed"}>Passed</MenuItem>
                <MenuItem value={"Failed"}>Failed</MenuItem>
                <MenuItem value={"Interrupted"} disabled={true}>
                  Interrupted
                </MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={24}
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "20px",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        {Object.keys(columnVisibility).map((key) => {
          return (
            key.toLocaleLowerCase() !== "scenario" &&
            key.toLocaleLowerCase() !== "result" && (
              <Grid item xs={1}>
                <FormControlLabel
                  key={key}
                  control={
                    <Checkbox
                      checked={columnVisibility[key]}
                      onChange={() => handleColumnToggle(key)}
                      color="primary"
                    />
                  }
                  label={key.toUpperCase()}
                />
              </Grid>
            )
          );
        })}
      </Grid>

      <Grid container spacing={24}>
        <Grid item xs={12}>
          <DataTable
            className="dataTables_wrapper"
            columns={filteredColumns.map((column) => ({
              ...column,
              name: (
                <Tooltip
                  title={column.tooltip}
                  placement="top"
                  onClick={() => handleTooltipClick(column)}
                >
                  <span>{column.name}</span>
                </Tooltip>
              ),
              cell: (rowData) => {
                if (column.selector === "result") {
                  return (
                    <strong
                      style={{
                        color:
                          rowData.result === "PASS" ? COLORS.PASS : COLORS.FAIL,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      {rowData.result}
                    </strong>
                  );
                }
                return rowData[column.selector];
              },
            }))}
            customStyles={customStyles}
            // conditionalRowStyles={conditionalRowStyles}
            data={rowsWithResult}
            defaultSortField="topology_tag_name"
            defaultSortAsc={true}
            // pagination
            highlightOnHover
            setFilter
            // paginationPerPage={5}
            // paginationRowsPerPageOptions={[5, 10, 15, 20]}
            // paginationRowsPerPageOptions="5"
            onRowClicked={handleRowClick}
          ></DataTable>
        </Grid>
        <Grid item xs={4}>
          {/* <CustomPieChart></CustomPieChart> */}
        </Grid>
      </Grid>

      {isOpenModal && (
        <CustomModal
          isOpen={isOpenModal}
          title="KPI Details"
          size="md"
          content={selectedModalContent}
          handleModalClose={handleModalClose}
        />
      )}
    </>
  );
};

export default TestScenarioDetail;
